import { render } from "./PlaybookViewTableCategory.vue?vue&type=template&id=42a1a8fc&scoped=true"
import script from "./PlaybookViewTableCategory.vue?vue&type=script&lang=js"
export * from "./PlaybookViewTableCategory.vue?vue&type=script&lang=js"

import "./PlaybookViewTableCategory.vue?vue&type=style&index=0&id=42a1a8fc&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/avalia-assess/avalia-playbook-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42a1a8fc"]])

export default __exports__